<template>
    <v-dialog v-model="dialog">
        <v-card>
            <div id="conteudoPDF" class="pdf-content">
                <v-card>
                    <v-card-title>
                        Relatório de Solicitação de Orçamento
                    </v-card-title>

                    <v-card-text>

                        <v-img
                            src="@/assets/logo_delta.jpg"
                            contain
                            height="100"
                            width="200"
                        />

                        <RelatorioSalesOrderTableView
                            :dados-tabela="dadosTabela"
                        />

                    </v-card-text>

                </v-card>

            </div>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="$emit('cancel')">Cancelar</v-btn>   
                <v-btn color="primary" @click="exportPdf">Gerar PDF</v-btn>  
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>


<script>
import RelatorioSalesOrderTableView  from './RelatorioSalesOrderTableView'
import html2pdf from 'html2pdf.js'

export default {
    components: { RelatorioSalesOrderTableView  },
    name: 'RelatorioListPreview',
    props: ['dadosTabela', 'isOpen'],
    data() {
        return {
            dialog: false
        }
    },

    methods: {
        exportPdf() {
            const elemento = document.getElementById("conteudoPDF");
            html2pdf()
            .set({
                margin: 10,
                filename: 'Relatorio-Solicitacao-Orcamento.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            })
            .from(elemento)
            .save();

            this.$emit('cancel')
        }
    },

    watch: {
        isOpen(value){
            this.dialog = value
        }
    },
}
</script>

<style scoped>

.pdf-content {
  font-family: 'Arial', sans-serif;
  font-size: 5px;
  padding: 0;
}

</style>